export const PROJECT_NAME = 'Airr';
